import qs from "qs";
import http from "../http";

function getTotalProjectProgress(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/project/${payload}/progress/total`
  );
}

function getTotalWorkProgress(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/task/${payload}/progress/total`
  );
}

function getTaskStatusProgressProject(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/project/${payload}/progress/task-status`
  );
}

function getTaskStatusProgressWork(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/task/${payload}/progress/task-status`
  );
}

function getDailyWorkloadProject(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/project/${payload.id}/workload/daily?term=${payload.term}`
  );
}

function getDailyWorkloadWork(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/task/${payload.id}/workload/daily?term=${payload.term}`
  );
}

function getTaskProgress(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/project/${
      payload.id
    }/progress/task?${qs.stringify(payload.option)}`
  );
}

function getPersonalAchievementProject(payload) {
  //quotaType
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/project/${payload.pId}/personal-achievement?quotaType=${payload.option.quotaType}
    &workType=${payload.option.workType}`
  );
}

function getPersonalAchievementWork(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/task/${payload.pId}/personal-achievement?quotaType=${payload.option.quotaType}
    &workType=${payload.option.workType}`
  );
}

function getConciseStatusProject(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/result/project/${payload}/concise-status`
  );
}

function getConciseStatusWork(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/result/task/${payload}/concise-status`
  );
}

function getResultClassProject(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/result/project/${payload}/classes`
  );
}

function getResultClassWork(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/result/task/${payload}/classes`
  );
}

function getClassAttributeResult(payload) {
  const suffix = `?classId=${payload.classId}&interfaceId=${payload.interfaceId}`;

  if (payload.type === "project") {
    return http(
      "GET",
      `${window.API_URL}/dashboard/result/project/${payload.id}/class/attributes` +
        suffix
    );
  } else {
    return http(
      "GET",
      `${window.API_URL}/dashboard/result/task/${payload.id}/class/attributes` +
        suffix
    );
  }
}
function getResultAttributeProject(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/result/project/${payload}/attributes`
  );
}
function getResultAttributeWork(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/result/task/${payload}/attributes`
  );
}

function getStatusItems(payload) {
  return http("POST", `${window.API_URL}/dashboard/status`, payload);
}

function getStatusItemsExcel(payload) {
  return http(
    "POST",
    `${window.API_URL}/dashboard/status/download`,
    payload,
    {},
    { responseType: "blob" }
  );
}

function isBatchInspectionProject(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/project/${payload}/auto-inspection/possibility`
  );
}

function setBatchInspectionProject(payload) {
  return http(
    "PUT",
    `${window.API_URL}/dashboard/project/${payload}/auto-inspection`
  );
}

function isBatchInspectionWork(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/task/${payload}/auto-inspection/possibility`
  );
}

function setBatchInspectionWork(payload) {
  return http(
    "PUT",
    `${window.API_URL}/dashboard/task/${payload}/auto-inspection`
  );
}

function getStatusFilterPeople(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/status/people/${
      payload.id
    }/${payload.type.toUpperCase()}`
  );
}

function getDashBoardManager(payload) {
  return http("POST", `${window.API_URL}/dashboard/manager`, payload);
}

function updateTaskAllocate(payload) {
  return http(
    "PUT",
    `${window.API_URL}/dashboard/manager/task/allocate`,
    payload
  );
}

function getManagerItemExcel(payload) {
  return http(
    "POST",
    `${window.API_URL}/dashboard/manager/download`,
    payload,
    {},
    { responseType: "blob" }
  );
}

function getOpTotalProjectProgress(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/project/${payload.id}/progress/total?quotaType=${payload.quotaType}`
  );
}

function getOpTotalTaskProgress(payload) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/summary/task/${payload.id}/progress/total?quotaType=${payload.quotaType}`
  );
}

/** get projects (dashboard left panel) */
function getDashboardProjects(params) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/common/tree/projects?${qs.stringify(params)}`
  );
}

/** get tasks (dashboard left panel) */
function getDashboardTasks(projectId) {
  return http(
    "GET",
    `${window.API_URL}/dashboard/common/tree/tasks?projectId=${projectId}`
  );
}

function getStatusFilterTask(payload) {
  return http("GET", `${window.API_URL}/dashboard/status/task/${payload.pid}`);
}

function getAllocates(payload) {
  return http(
    "GET",
    `${window.API_URL}/set-allocates?${qs.stringify(payload)}`
  );
}

function patchAllocates(params, body) {
  return http(
    "PATCH",
    `${window.API_URL}/set-allocates?${qs.stringify(params)}`,
    body
  );
}

export default {
  getTotalProjectProgress,
  getTotalWorkProgress,
  getTaskStatusProgressProject,
  getTaskStatusProgressWork,
  getDailyWorkloadProject,
  getDailyWorkloadWork,
  getTaskProgress,
  getPersonalAchievementProject,
  getPersonalAchievementWork,
  getConciseStatusProject,
  getConciseStatusWork,
  getResultClassProject,
  getResultClassWork,
  getClassAttributeResult,
  getResultAttributeProject,
  getResultAttributeWork,
  getStatusItems,
  getStatusItemsExcel,
  isBatchInspectionProject,
  setBatchInspectionProject,
  isBatchInspectionWork,
  setBatchInspectionWork,
  getStatusFilterPeople,
  getDashBoardManager,
  updateTaskAllocate,
  getManagerItemExcel,
  getOpTotalProjectProgress,
  getOpTotalTaskProgress,
  getStatusFilterTask,
  getAllocates,
  patchAllocates,
  getDashboardProjects,
  getDashboardTasks,
};
